import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/',
      redirect: '/login'
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('./views/login.vue')
    },
    {
      path: '/index',
      name: 'index',
      component: () => import('./views/index.vue')
    },
    {
      path: '/Statistics',
      name: 'Statistics',
      component: () => import('./views/Statistics.vue')
    },
    {
      path: '/checkClothCount',
      name: 'checkClothCount',
      component: () => import('./views/checkClothCount.vue')
    },
    {
      path: '/StoreTurnover',
      name: 'StoreTurnover',
      component: () => import('./views/StoreTurnover.vue')
    },
    {
      path: '/exitFactory',
      name: 'exitFactory',
      component: () => import('./views/exitFactory.vue')
    },
    {
      path: '/clothingInquiries',
      name: 'clothingInquiries',
      component: () => import('./views/clothingInquiries.vue')
    },
    {
      path: '/productionEarlyWarning',
      name: 'productionEarlyWarning',
      component: () => import('./views/productionEarlyWarning.vue')
    },
    {
      path: '/workload',
      name: 'workload',
      component: () => import('./views/workload.vue')
    },
    {
      path: '/dropMark',
      name: 'dropMark',
      component: () => import('./views/dropMark.vue')
    },
    {
      path: '/enterFactory',
      name: 'enterFactory',
      component: () => import('./views/enterFactory.vue')
    },
    {
      path: '/factory',
      name: 'factory',
      component: () => import('./views/factory.vue')
    },
    {
      path: '/rework',
      name: 'rework',
      component: () => import('./views/ReworkManagement.vue')
    },
    {
      path: '/compensation',
      name: 'compensation',
      component: () => import('./views/CompensationManagement.vue')
    }
  ]
})
